// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"af9e1c6f","455":"7ea15b92"}[chunkId] + ".chunk.js";
};